import React from "react";
import { Checkbox } from "../../components";

export interface MarketingConsentInput {
  marketingConsent: boolean;
}

interface MarketingConsentProps {
  marketingConsent: React.ReactNode;
  values: MarketingConsentInput;
  setFieldValue: (field: string, value: any) => void;
}

export function MarketingConsent(props: MarketingConsentProps) {
  const { values, marketingConsent, setFieldValue } = props;

  return (
    <div className="d-flex gap-3">
      <Checkbox
        value={values.marketingConsent}
        onChange={(v) => setFieldValue("marketingConsent", v)}
      />
      <div className="text-break">{marketingConsent}</div>
    </div>
  );
}
